/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Conversation_Not_FoundInputs */

const en_us2_conversation_not_found = /** @type {(inputs: Conversation_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This conversation no longer exists.`)
};

const pt_br2_conversation_not_found = /** @type {(inputs: Conversation_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essa conversa não existe mais.`)
};

const es_419_conversation_not_found = /** @type {(inputs: Conversation_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta conversación ya no existe.`)
};

const pt_pt2_conversation_not_found = /** @type {(inputs: Conversation_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta conversa já não existe.`)
};

const fr_fr2_conversation_not_found = /** @type {(inputs: Conversation_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette conversation n'existe plus.`)
};

const de_de2_conversation_not_found = /** @type {(inputs: Conversation_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Unterhaltung existiert nicht mehr.`)
};

const it_it2_conversation_not_found = /** @type {(inputs: Conversation_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questa conversazione non esiste più.`)
};

/**
* | output |
* | --- |
* | "This conversation no longer exists." |
*
* @param {Conversation_Not_FoundInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const conversation_not_found = /** @type {((inputs?: Conversation_Not_FoundInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Conversation_Not_FoundInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_conversation_not_found(inputs)
	if (locale === "es-419") return es_419_conversation_not_found(inputs)
	if (locale === "pt-PT") return pt_pt2_conversation_not_found(inputs)
	if (locale === "fr-FR") return fr_fr2_conversation_not_found(inputs)
	if (locale === "de-DE") return de_de2_conversation_not_found(inputs)
	if (locale === "it-IT") return it_it2_conversation_not_found(inputs)
	return en_us2_conversation_not_found(inputs)
});
export { conversation_not_found as "conversation.not_found" }